var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.87 77.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 38.78,
    x2: 156.87,
    y2: 38.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8b5cf6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.24,0c-7.34,0-12.75,3.67-17.17,7.99h-.43l-1.19-6.7h-31.86c-2.48-.86-5.4-1.3-8.42-1.3-3.77,0-7.44.68-10.69,2.01-2.12-.98-4.6-1.53-7.51-1.53-7.13,0-12.1,4.1-16.74,8.86C43.53,3.62,38.88.49,31.43.49s-11.88,3.67-16.2,7.99h-.43l-1.19-6.7H0v53.68h16.63V19.5c3.24-3.24,6.16-4.86,8.64-4.86,4.32,0,6.26,2.27,6.26,9.72v31.11h16.74V19.5c3.24-3.24,6.05-4.86,8.64-4.86.84,0,1.58.11,2.25.31-.31,1.4-.47,2.9-.47,4.49,0,6.26,3.46,11.23,7.24,13.83v.43c-3.46,2.48-5.94,6.37-5.94,10.15,0,4.43,2.05,7.24,4.86,9.18v.43c-4.97,2.59-7.56,6.16-7.56,10.59,0,9.61,10.05,13.5,22.47,13.5,18.69,0,30.46-7.99,30.46-19.33,0-1.16-.11-2.24-.32-3.24h14.58V19.01c3.35-3.02,5.62-4.86,9.4-4.86,4.32,0,6.27,2.27,6.27,9.72v31s0,.07,0,.11h16.74V21.71c0-13.39-4.97-21.71-16.63-21.71ZM81.16,11.13c4,0,6.8,2.81,6.8,8.32s-2.81,8.53-6.8,8.53-6.8-2.92-6.8-8.53,2.81-8.32,6.8-8.32ZM82.46,67.18c-6.91,0-11.45-1.94-11.45-5.83,0-1.73.86-3.24,2.59-4.75,1.62.43,3.67.65,7.56.65h5.18c5.08,0,7.88.65,7.88,3.89,0,3.46-4.97,6.05-11.77,6.05ZM107.83,50.43c-3.17-4.12-9.45-5.93-18.36-5.93h-8.53c-5.72,0-7.88-1.19-7.88-3.78,0-1.73.54-2.59,1.73-3.67,2.38.65,4.54.97,6.37.97,11.88,0,21.39-5.51,21.39-18.04,0-2.59-.76-5.08-1.62-6.59h6.91v37.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.22d7416496673e11ba7685160cc4a239.svg";
export { ForwardRef as ReactComponent };